import api from "../apiClient";

export const getPageBySlug = async (slug: string, language = "en") => {
  const response = await api.get(`/api/content/pages`, {
    params: { slug, language },
  });
  return response.data;
};
